import * as React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyState: React.FC = props => (
  <Wrapper>
    <h2>{props.children}</h2>
  </Wrapper>
);



// WEBPACK FOOTER //
// ./src/library/EmptyState.tsx